/*!
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { SelectionState, ProfileState, NavigationState } from '@alfresco/adf-extensions';
import { Group, Person, RepositoryInfo, SiteRole, VersionEntry } from '@alfresco/js-api';
import { InjectionToken } from '@angular/core';

export const STORE_INITIAL_APP_DATA = new InjectionToken<AppState>('STORE_INITIAL_APP_DATA');

export interface AppState {
  appName: string;
  logoPath: string;
  customCssPath: string;
  webFontPath: string;
  sharedUrl: string;
  currentNodeVersion: VersionEntry;
  selection: SelectionState;
  user: ProfileState;
  userSiteRoles: SiteRole[];
  userList: Person[];
  groupList: Group[];
  sharedFilesNodeId: string;
  navigation: NavigationState;
  infoDrawerOpened: boolean;
  infoDrawerPreview: boolean;
  infoDrawerMetadataAspect: string;
  showFacetFilter: boolean;
  repository: RepositoryInfo;
  fileUploadingDialog: boolean;
  showLoader: boolean;
}

export interface AppStore {
  app: AppState;
}
